import React from "react";

export default function VideoBlockHeading({ children }) {
  return (
    <div className='video-block-heading'>
      {children}
    </div>
  );
}
